__webpack_require__.p = "/apps/platform-admin/";